'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var DEFAULT_COLOR = exports.DEFAULT_COLOR = '#425b76';


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsBase/target/src/MeetingsBase/static-1.2449/js/constants/colors.js
// module id = 169
// module chunks = 0